import React from 'react'
import { useEffect, useState } from 'react';
import './FaultSecondPageCustom.css';

import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import NoData from '../../Driveanalysis/NoData';
import COmpBiDirTest from './FaultSecondPageChartsBidirRender';
import ChartLoader from '../../Driveanalysis/ChartLoader';

export default function FaultSecondPageChartsBidir(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [defaultNav, setDefaultNav] = useState("BCS");
  const [dataMain, setDataMain] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "268px" }); //width: "565px",
  // #ffa344 #358696
  const [topping, setTopping] = useState("Fault")

  const [toCalculate, setToCalculate] = useState(0)

  const onRadioChange = e => {
    setTopping(e.target.value)
  }

  const responceDataNew = (data) => {
    const objArray = [];
    Object.keys(data).forEach(key => objArray.push({
      name: key,
      rating: data[key]
    }))

    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU"];
    mainECU.forEach(element => {
      var index = objArray.findIndex(x => x.name == element);
      index === -1 && objArray.push({
        "name": element, "rating": { "value": 0 }
      })
    });

    const objArrayA = objArray.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    const foodBar = objArrayA.find(item => item.name === defaultNav);
    setToCalculate(foodBar.rating.value);
  }

  const responceData = (data) => {
    let dataArray = [];
    let maleAdd = 0;
    (topping === "DTC") ? maleAdd = maleAdd : maleAdd = toCalculate;

    let femaleAdd = 0;
    data.forEach((obj1, index) => {
      if (topping === "DTC") {
        maleAdd += obj1.NumOfTime.value;
      }
      femaleAdd += obj1.occ.value;
    })
    // let widthCnt = 0;
    data.forEach((obj1, index) => {
      let male = (obj1.NumOfTime.value / maleAdd) * 100;
      let female = (obj1.occ.value / femaleAdd) * 100;
      dataArray.push({ age: obj1.key.L4_Signal_Name.toUpperCase(), male: -male, female: female, orgLevalMale: obj1.NumOfTime.value.toString(), orgLevalFemale: obj1.occ.value.toString(), signal_nm: obj1.key.L4_Signal_Name, signal_desc: obj1.key.signal_value, signal_val: obj1.key.Fault_Alarm_Value })
    })

    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }

    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray)
  }

  useEffect(() => {
    if (topping === "Fault") {
      fetchData({ url: API_URL_MAIN + 'faultsecondpage/barFaultAnanysis', body: { selected: 'duration', startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceDataNew);
    } else {
      fetchData({ url: API_URL_MAIN + 'faultsecondpage/barFaultAnanysisAlertCalculator', body: { selected: 'duration', startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceDataNew);
    }
    fetchData({ url: API_URL_MAIN + 'faultsecondpage/vehicleLeval' + topping, body: { defaultNav: defaultNav, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceData);
  }, [topping, defaultNav, props, toCalculate])

  function getNavTab(e, name) {
    setDefaultNav(name);
  }

  return (
    <div className="col-md-12 col-lg-6 col-sm-12 mgt-2">
      <div className="v-title chartbox3">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-lg-6">
            <div className="titlebg">Vehicle Level Fault/Alarm/DTC list</div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6" style={{ textAlign: 'end' }}>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Fault" value="Fault" checked={topping === "Fault"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio1">Fault</label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Alarm" value="Alarm" checked={topping === "Alarm"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio2">Alert</label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="DTC" value="DTC" checked={topping === "DTC"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio2">DTC</label>
            </div>
          </div>
        </div>
        <div className="chartHGT">
          <div className="mt-2 mb-2">
            <div className="mt-3">
              <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
                <li className="nav-item">
                  <a className="nav-link active" data-bs-toggle="tab" href="#BCS" onClick={(e) => getNavTab(e, "BCS")}>BCS</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#MCU" onClick={(e) => getNavTab(e, "MCU")}>MCU</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#VCU" onClick={(e) => getNavTab(e, "VCU")}>VCU</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#DCDC" onClick={(e) => getNavTab(e, "DCDC")}>DCDC</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#OBC" onClick={(e) => getNavTab(e, "OBC")}>OBC</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#BMS" onClick={(e) => getNavTab(e, "BMS")}>BMS</a>
                </li>
              </ul>
              <div className="tab-content">
                <div className='row' style={{ textAlign: 'right' }}>
                  <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                    <dt className="red" ></dt>
                    <dd>Time Duration (mins)</dd>
                    <dt className="yellow" style={{ marginLeft: "5px" }}></dt>
                    <dd>Occurrence</dd>
                  </dl>
                </div>
                <div id="BCS" className="tab-pane active"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest dataMain={dataMain} id={"chartdivBCS"} /> :
                          <NoData />)
                      }
                    </div>
                  </div>
                </div>
                <div id="MCU" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest dataMain={dataMain} id={"chartdivMCU"} /> :
                          <NoData />)
                      }
                    </div>
                  </div>
                </div>
                <div id="VCU" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest dataMain={dataMain} id={"chartdivVCU"} /> :
                          <NoData />)
                      }
                    </div>
                  </div>
                </div>
                <div id="DCDC" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest dataMain={dataMain} id={"chartdivDCDC"} /> :
                          <NoData />)
                      }
                    </div>
                  </div>
                </div>
                <div id="OBC" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest dataMain={dataMain} id={"chartdivOBC"} /> :
                          <NoData />)
                      }
                    </div>
                  </div>
                </div>
                <div id="BMS" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest dataMain={dataMain} id={"chartdivBMS"} /> :
                          <NoData />)
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
